import { render } from "./payPending.vue?vue&type=template&id=5fad334c&scoped=true"
import script from "./payPending.vue?vue&type=script&lang=js"
export * from "./payPending.vue?vue&type=script&lang=js"

import "./payPending.vue?vue&type=style&index=0&id=5fad334c&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fad334c"]])

export default __exports__